import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CommonNav from "../../main/CommonNav";
import Footer from "../../main/Footer";

import BuddibleSocket, { MsgIDList } from "../../lib/BuddibleSocket";
import Utilities from "../../lib/Utilities";
import CodeList from "../../lib/CodeList";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

const _mClassName = "PostDetail";
const _urls = {
  notice: {
    key: "nt",
    selectDetail: "/notice/JS_notice_select.php",
    selectReply: "",
    insertReply: "",
    updateReply: "",
  }, //nt
  carrierNotice: {
    key: "pr",
    selectDetail: "/logistoryBoard/JS_postLogistorySelect.php",
    selectReply: "/logistoryBoard/JS_logistory_select_replay.php",
    insertReply: "/logistoryBoard/JS_logistory_insert_replay.php",
    updateReply: "/logistoryBoard/JS_logistory_update_replay.php",
  }, //pr
  qna: {
    key: "qa",
    selectDetail: "/qa/JS_qa_select.php",
    selectReply: "/qa/JS_qa_select_replay.php",
    insertReply: "/qa/JS_qa_insert_replay.php",
    updateReply: "/qa/JS_qa_update_replay.php",
  }, //qa
  promotion: {
    key: "pr",
    selectDetail: "/promotion/JS_promotion_select.php",
    selectReply: "",
    insertReply: "",
    updateReply: "",
  }, //pr
};
const replyKey = { qna: "qr", carrierNotice: "prr" };
let isInit = false;

export default function PostDetail() {
  const { post_type, idx } = useParams();
  const { t, i18n } = useTranslation();
  const [loginInfo, setLoginInfo] = useState(null);
  const [sideList, setSideList] = useState([]);
  const [detail, setDetail] = useState(null);
  const [replyList, setReplyList] = useState([]);
  const [modifyReply, setModifyReply] = useState(null);
  const replyInput = useRef();

  /**/
  (() => {
    socket.addLocalEventListener(
      MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
      _mClassName,
      (b, n) => {
        if (n) {
          if (n["returnData"].length) {
            setLoginInfo({ ...n["returnData"][0] });
          }
        }
      }
    );
  })();

  useEffect(() => {
    i18n.changeLanguage(i18n.language);
    let userdata = socket.getLocalDataSet(MsgIDList.EVENT_LOGIN_AUTO_SUCCESS);
    if (userdata) {
      if (userdata["returnData"].length) {
        setLoginInfo(userdata["returnData"][0]);
      }
    }
    return () => {
      socket.removeLocalEventListener(
        MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
        _mClassName
      );
    };
  }, []);

  useEffect(() => {
    SELECT_POST(true, (response) => {
      setSideList(response);
      SELECT_POST(false, (response) => {
        isInit = true;
        if (response.length > 0) {
          setDetail(response[0]);
        } else {
          setDetail(null);
        }
        if (post_type === "qna" || post_type === "carrierNotice") {
          SELECT_POST_REPLY();
        }
      });
    });
  }, [idx]);

  function SELECT_POST(isList, callback) {
    const msgID = util.makeUUIDv4();

    const file = _urls[post_type].selectDetail;
    const socketMsg = {
      msgID: msgID,
      file: file,
      data: {},
      take: 10,
      page: 1,
      skip: 0,
    };
    if (!isList) {
      delete socketMsg.take;
      const key = `${_urls[post_type].key}IDX`;
      socketMsg[key] = idx;
    }

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData && newData["ret"]) {
        let response = [];
        for (let i = 0; i < newData["returnData"].length; i++) {
          const data = newData["returnData"][i];
          const key = _urls[post_type].key;
          const setData = {
            IDX: data[`${key}IDX`],
            COMPCD: data[`${key}CompCD`],
            USERID: data[`${key}USERID`],
            TITLE: data[`${key}TITLE`],
            CONTENTS: data[`${key}CONTENTS`],
            CreateDate: util.getDateToFormat(
              data[`${key}CreateDate`],
              "YYYY.MM.DD"
            ),
            UpdateDate: util.getDateToFormat(
              data[`${key}UpdateDate`],
              "YYYY.MM.DD"
            ),
            Files: data[`${key}Files`],
            basicData: { ...data },
          };
          if (_urls[post_type].key !== "pr") {
            setData.sName = data.sName;
          }

          response.push(setData);
        }

        callback && callback(response);
      }
    });
  }

  function SELECT_POST_REPLY() {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: _urls[post_type].selectReply,
      msgID: msgID,
      data: {},
    };
    socketMsg[`${_urls[post_type].key}IDX`] = idx;
    socketMsg[`${replyKey[post_type]}IDX`] = idx;

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData.ret) {
          const response = [];
          for (let i = 0; i < newData["returnData"].length; i++) {
            const data = newData["returnData"][i];
            const useYN = data[`${replyKey[post_type]}USEYN`];
            if (useYN === "N") continue;

            const updateDate = new Date(
              data[`${replyKey[post_type]}UpdateDate`]
            );
            const UpdateDate = util.getDateToFormat(updateDate, "YYYY.MM.DD");
            const hour =
              updateDate.getHours() > 9
                ? updateDate.getHours()
                : "0" + updateDate.getHours();
            const min =
              updateDate.getMinutes() > 9
                ? updateDate.getMinutes()
                : "0" + updateDate.getMinutes();

            response.push({
              IDX: data[`${replyKey[post_type]}IDX`],
              IDXMain: data[`${replyKey[post_type]}IDXMain`],
              Comment: data[`${replyKey[post_type]}Comment`],
              CompCD: data[`${replyKey[post_type]}CompCD`],
              CompNM: data[`${replyKey[post_type]}CompNM`],
              CreateDate: data[`${replyKey[post_type]}CreateDate`],
              USERID: data[`${replyKey[post_type]}USERID`],
              USERNM: data[`${replyKey[post_type]}USERNM`],
              USEYN: data[`${replyKey[post_type]}USEYN`],
              UpdateDate: `${UpdateDate} ${hour}:${min}`,
            });
          }
          setReplyList(response);
        }
      }
    });
  }

  function INSERT_POST_REPLY() {
    if (replyInput.current.value.trim() === "") {
      codeList.Modal.current.alert(t("post.msg.enterReply"));
      return;
    }
    if (!loginInfo) {
      codeList.Modal.current.alert(t("commonMSG.requiresLogin"));
      return;
    }
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: _urls[post_type].insertReply,
      msgID: msgID,
      data: {},
      [`${replyKey[post_type]}IDXMain`]: idx,
      [`${replyKey[post_type]}Comment`]: replyInput.current.value,
      [`${replyKey[post_type]}INSERTDATE`]: new Date(),
      [`${replyKey[post_type]}CompCD`]: loginInfo.comp_cd,
      [`${replyKey[post_type]}USERID`]: loginInfo.user_id,
      [`${replyKey[post_type]}CompNM`]: loginInfo.comp_nm,
      [`${replyKey[post_type]}USERNM`]: loginInfo.user_nm,
      [`${replyKey[post_type]}USEYN`]: "Y",
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          codeList.Modal.current.alert(t("post.msg.successSaveReply"), () => {
            replyInput.current.value = "";
            SELECT_POST_REPLY();
          });
        }
      }
    });
  }

  function UPDATE_POST_REPLY(useYN = "Y", data = null) {
    if (useYN === "Y" && replyInput.current.value.trim() === "") {
      codeList.Modal.current.alert(t("commonMSG.enterDetail"));
      return;
    }

    if (!data) {
      codeList.Modal.current.alert(t("commonMSG.error"));
      return;
    }

    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: _urls[post_type].updateReply,
      msgID: msgID,
      data: {},
      [`${replyKey[post_type]}IDX`]: data["IDX"], //php idx key 참고
      [`${replyKey[post_type]}IDXMain`]: idx, //php idx key 참고
      [`${replyKey[post_type]}Comment`]:
        useYN === "Y" ? replyInput.current.value : data["Comment"],
      [`${replyKey[post_type]}INSERTDATE`]: new Date(),
      [`${replyKey[post_type]}CompCD`]: loginInfo.comp_cd,
      [`${replyKey[post_type]}USERID`]: loginInfo.user_id,
      [`${replyKey[post_type]}CompNM`]: loginInfo.comp_nm,
      [`${replyKey[post_type]}USERNM`]: loginInfo.user_nm,
      [`${replyKey[post_type]}USEYN`]: useYN,
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          const msg =
            useYN === "Y"
              ? t("post.msg.successSaveReply")
              : t("post.msg.successDeleteReply");
          codeList.Modal.current.alert(msg, () => {
            replyInput.current.value = "";
            setModifyReply(null);
            SELECT_POST_REPLY();
          });
        }
      }
    });
  }

  function saveReply() {
    if (modifyReply !== null) {
      UPDATE_POST_REPLY("Y", modifyReply);
    } else {
      INSERT_POST_REPLY();
    }
  }

  function editReply(data) {
    replyInput.current.value = data["Comment"];
    setModifyReply(data);
  }

  function deleteReply(data) {
    const comment = data["Comment"];
    const truncated =
      comment.length > 20 ? comment.slice(0, 20) + "..." : comment;
    codeList.Modal.current.confirm(
      `[${truncated}]${t("post.msg.confirmDeleteReply")}`,
      (ret) => {
        if (ret) {
          setModifyReply(data);
          UPDATE_POST_REPLY("N", data);
        }
      }
    );
  }

  async function copyURL() {
    try {
      await navigator.clipboard.writeText(window.location.href);
      codeList.Modal.current.alert(t("commonMSG.copyURL"));
    } catch (e) {
      codeList.Modal.current.alert(t("commonMSG.error"));
    }
  }

  return (
    <>
      <CommonNav />
      <main className="py-4 mvh-100">
        <div className="container h-100">
          <div className="row h-100 m-0 p-0 py-5">
            <div className="col-12 col-lg-9 h-100 m-0 p-2 pr-lg-4 border-right order-1 order-lg-0">
              {detail && (
                <div className="p-3 ">
                  <div className="pb-3 mb-2">
                    <p
                      className="h5 font-weight-900"
                      style={{ lineHeight: 1.4 }}
                    >
                      {detail["TITLE"]}
                    </p>
                    <div className="d-flex flex-row justify-content-between align-items-center">
                      <p className="text-secondary">
                        {t("post.registrationDate")} {detail.CreateDate} ·{" "}
                        {t("post.modifyDate")} {detail.UpdateDate}
                        {detail.sName && (
                          <span className="d-inline-block ml-1 rounded-pill border px-2">
                            {detail.sName}
                          </span>
                        )}
                      </p>
                      <div>
                        {post_type === "carrierNotice" &&
                          loginInfo &&
                          (detail.USERID === loginInfo.user_id ||
                            loginInfo.comp_cd.startsWith("Z")) && (
                            <Link
                              className="mr-2"
                              to={`/WriteLogiStory/${detail.IDX}`}
                            >
                              <i className="fa-regular fa-pen-to-square" />
                            </Link>
                          )}
                        <span className="cursor_pointer" onClick={copyURL}>
                          <i className="fa-regular fa-share-from-square" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className="h6 font-weight-normal mb-5"
                    dangerouslySetInnerHTML={{ __html: detail["CONTENTS"] }}
                    style={{ whiteSpace: "break-spaces", lineHeight: 1.6 }}
                  />
                  {detail["Files"] && (
                    <div className="mb-5 py-3">
                      ※{t("post.attach")}
                      <div className="m-0 p-0">
                        {detail.Files.split("|").map((v, i) => {
                          let splitData = v.split("?");
                          if (splitData.length === 1) return null;
                          let fileName = splitData[0];
                          let fileLink = splitData[1];
                          return (
                            <div className="my-2" key={v}>
                              {fileName.endsWith(".pdf") && (
                                <a
                                  className="text-primary font-weight-bold border-0"
                                  href={fileLink}
                                  download={fileName}
                                  target="_blank"
                                >
                                  {fileName}
                                </a>
                              )}
                              {!fileName.endsWith(".pdf") && (
                                <button
                                  className="btn_1"
                                  onClick={() =>
                                    util.downloadAs(fileLink, fileName)
                                  }
                                >
                                  <i className="fas fa-download" /> {fileName}
                                </button>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                  <div className="d-flex flex-row justify-content-center align-items-center">
                    <span
                      className="d-inline-block h6 mb-0 cursor_pointer border border-secondary text-secondary py-2 px-4 mr-1"
                      onClick={copyURL}
                    >
                      {t("post.share")}{" "}
                      <i className="fa-regular fa-share-from-square" />
                    </span>
                    <Link
                      to={`/PostList/${post_type}`}
                      className="d-inline-block h6 mb-0 cursor_pointer border border-info text-info py-2 px-4 ml-1"
                    >
                      {t("post.goToList")}{" "}
                      <i className="fa-regular fa-circle-right" />
                    </Link>
                  </div>
                  {(post_type === "carrierNotice" || post_type === "qna") && (
                    <div className="mt-5 border-top pt-3">
                      <p className="font-weight-bold">
                        {replyList.length}
                        {t("post.countReply")}
                      </p>
                      <div className="border p-2 my-2 d-flex flex-row justify-content-between align-items-center rounded">
                        <input
                          type="text"
                          className="border-0 flex-fill"
                          placeholder={t("post.msg.enterReply")}
                          ref={replyInput}
                        />
                        <span
                          className="mb-0 mx-2 text-secondary cursor_pointer font-weight-bold"
                          onClick={saveReply}
                        >
                          {t("post.post")}
                        </span>
                      </div>
                      {replyList.map((data, index) => {
                        return (
                          <div
                            key={data["IDX"]}
                            className="py-3 px-1 border-bottom"
                          >
                            <div className="d-flex flex-row justify-content-between">
                              <div>
                                <p className="font-weight-900">
                                  {data["USERNM"]}
                                </p>
                                <p className="font-size-09 text-secondary">
                                  {data["CompNM"]} · {data["UpdateDate"]}
                                </p>
                              </div>
                              {loginInfo &&
                                ((loginInfo.comp_cd === data["CompCD"] &&
                                  loginInfo.user_id === data["USERID"]) ||
                                  loginInfo.comp_cd === "Z0001") && (
                                  <div className="d-flex flex-row">
                                    <span
                                      className="cursor_pointer mr-2"
                                      onClick={() => editReply(data)}
                                    >
                                      <i className="fa-regular fa-pen-to-square" />
                                    </span>
                                    <span
                                      className="cursor_pointer"
                                      onClick={() => deleteReply(data)}
                                    >
                                      <i className="fa-regular fa-trash-can" />
                                    </span>
                                  </div>
                                )}
                            </div>
                            <p className="pt-2">{data["Comment"]}</p>
                          </div>
                        );
                      })}
                      {replyList.length === 0 && (
                        <div className="d-flex flex-row justify-content-center align-items-center bg-light text-secondary p-5 rounded-lg">
                          <p>{t("commonMSG.noData")}</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
              {!isInit && (
                <div
                  className="p-3  d-flex flex-column justify-content-center align-items-center text-secondary"
                  style={{ minHeight: 500 }}
                >
                  <p className="h6 mb-1 font-weight-bold">
                    <i className="fa-solid fa-spinner rotate" />
                  </p>
                </div>
              )}
              {isInit && detail === null && (
                <div
                  className="p-3  d-flex flex-column justify-content-center align-items-center text-secondary"
                  style={{ minHeight: 500 }}
                >
                  <p className="h6 mb-1 font-weight-bold">
                    {t("commonMSG.invalidURL")}
                  </p>
                  <Link to={`/PostList/${post_type}`}>
                    {t("post.goToList")} →
                  </Link>
                </div>
              )}
            </div>
            <div className="col-12 col-lg-3 h-100 m-0 p-2 order-0 order-lg-1">
              <div className="p-3">
                <p className="h6 mb-2 font-weight-bold text-freiscop">
                  {t("post.viewMoreRelatedPosts")}
                </p>
                {sideList.map((data, index) => {
                  return (
                    <Link
                      to={`/PostDetail/${post_type}/${data["IDX"]}`}
                      key={index}
                      className={`py-2 ${
                        index === 0 ? "" : "border-top"
                      } rounded d-flex flex-row justify-content-between align-items-center`}
                    >
                      <p className="mb-0 w-75 text-truncate">{data["TITLE"]}</p>
                      <p className="font-size-09 text-secondary">
                        {data["CreateDate"]}
                      </p>
                    </Link>
                  );
                })}
                <Link
                  to="/WritePost"
                  className="btn btn-sm btn-outline-info rounded-sm mt-3 w-100 text-center"
                >
                  {t("post.main.writeInquiry")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
